import * as ambassadorWixEcomV1CheckoutTemplate from './ecom-v1-checkout-template-checkout-templates.http.js';
import * as ambassadorWixEcomV1CheckoutTemplateTypes from './ecom-v1-checkout-template-checkout-templates.types.js';
import * as ambassadorWixEcomV1CheckoutTemplateUniversalTypes from './ecom-v1-checkout-template-checkout-templates.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function createCheckoutTemplate(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutTemplateResponse &
    ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutTemplateResponseNonNullableFields,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutTemplateResponse &
    ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutTemplateResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.createCheckoutTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout-templates',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function getCheckoutTemplate(): __PublicMethodMetaInfo<
  'GET',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.GetCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.GetCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.GetCheckoutTemplateResponse &
    ambassadorWixEcomV1CheckoutTemplateUniversalTypes.GetCheckoutTemplateResponseNonNullableFields,
  ambassadorWixEcomV1CheckoutTemplateTypes.GetCheckoutTemplateResponse &
    ambassadorWixEcomV1CheckoutTemplateTypes.GetCheckoutTemplateResponseNonNullableFields
> {
  const payload = { checkoutTemplateId: ':checkoutTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.getCheckoutTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/checkout-templates/{checkoutTemplateId}',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function updateCheckoutTemplate(): __PublicMethodMetaInfo<
  'PATCH',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.UpdateCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.UpdateCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.UpdateCheckoutTemplateResponse &
    ambassadorWixEcomV1CheckoutTemplateUniversalTypes.UpdateCheckoutTemplateResponseNonNullableFields,
  ambassadorWixEcomV1CheckoutTemplateTypes.UpdateCheckoutTemplateResponse &
    ambassadorWixEcomV1CheckoutTemplateTypes.UpdateCheckoutTemplateResponseNonNullableFields
> {
  const payload = { checkoutTemplate: { id: ':checkoutTemplateId' } } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.updateCheckoutTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'PATCH',
    path: '/v1/checkout-templates/{checkoutTemplate.id}',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function deleteCheckoutTemplate(): __PublicMethodMetaInfo<
  'DELETE',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.DeleteCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.DeleteCheckoutTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.DeleteCheckoutTemplateResponse,
  ambassadorWixEcomV1CheckoutTemplateTypes.DeleteCheckoutTemplateResponse
> {
  const payload = { checkoutTemplateId: ':checkoutTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.deleteCheckoutTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'DELETE',
    path: '/v1/checkout-templates/{checkoutTemplateId}',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryCheckoutTemplates(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.QueryCheckoutTemplatesRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.QueryCheckoutTemplatesRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.QueryCheckoutTemplatesResponse &
    ambassadorWixEcomV1CheckoutTemplateUniversalTypes.QueryCheckoutTemplatesResponseNonNullableFields,
  ambassadorWixEcomV1CheckoutTemplateTypes.QueryCheckoutTemplatesResponse &
    ambassadorWixEcomV1CheckoutTemplateTypes.QueryCheckoutTemplatesResponseNonNullableFields
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.queryCheckoutTemplates(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout-templates/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createCheckoutFromTemplate(): __PublicMethodMetaInfo<
  'POST',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutFromTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutFromTemplateRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutFromTemplateResponse &
    ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateCheckoutFromTemplateResponseNonNullableFields,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutFromTemplateResponse &
    ambassadorWixEcomV1CheckoutTemplateTypes.CreateCheckoutFromTemplateResponseNonNullableFields
> {
  const payload = { checkoutTemplateId: ':checkoutTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.createCheckoutFromTemplate(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/checkout-templates/{checkoutTemplateId}/create-checkout-from-template',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function createAndRedirectToCheckout(): __PublicMethodMetaInfo<
  'GET',
  { checkoutTemplateId: string },
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.CreateAndRedirectToCheckoutRequest,
  ambassadorWixEcomV1CheckoutTemplateTypes.CreateAndRedirectToCheckoutRequest,
  ambassadorWixEcomV1CheckoutTemplateUniversalTypes.RawHttpResponse &
    ambassadorWixEcomV1CheckoutTemplateUniversalTypes.RawHttpResponseNonNullableFields,
  ambassadorWixEcomV1CheckoutTemplateTypes.RawHttpResponse &
    ambassadorWixEcomV1CheckoutTemplateTypes.RawHttpResponseNonNullableFields
> {
  const payload = { checkoutTemplateId: ':checkoutTemplateId' } as any;

  const getRequestOptions =
    ambassadorWixEcomV1CheckoutTemplate.createAndRedirectToCheckout(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/checkout-templates/{checkoutTemplateId}/create-and-redirect-to-checkout',
    pathParams: { checkoutTemplateId: 'checkoutTemplateId' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}
